import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Modal from 'react-modal';
import Parser from 'html-react-parser';
import { Input, PasswordInput } from 'shared/components';
import './RegisterForm.scss';
import ReCAPTCHA from 'react-google-recaptcha';

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
};

class RegisterForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      terms: false,
      modalIsOpen: false,
    };

    this.closeModal = this.closeModal.bind(this);
    this.openTermsModal = this.openTermsModal.bind(this);
    this.handleTermsCheck = this.handleTermsCheck.bind(this);
    this.recaptchaRef = React.createRef();
  }

  handleTermsCheck(e) {
    this.setState({
      terms: e.target.checked,
    });
    this.props.onChange({ terms: e.target.checked });
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
    });
  }

  openTermsModal(e) {
    e.preventDefault();
    this.setState({
      modalIsOpen: true,
    });
  }

  handleCaptcha = () => {
    this.props.handleCaptcha(this.recaptchaRef.current.getValue());
  };

  render() {
    return (
      <section className="register-form-section">
        <h4 className="text-center">{this.props.t('register.createAccountTitle')}</h4>
        <form className="register-form" onSubmit={this.props.onSubmit} noValidate>
          <Input
            size="w-100"
            type="email"
            name="emailAddress"
            value={this.props.user.emailAddress}
            placeholder={this.props.t('register.emailAddressPlaceholder')}
            onChange={this.props.onChange}
            errors={this.props.errors.emailAddress}
            required
          />
          <PasswordInput
            id="password"
            value={this.props.user.password}
            errors={this.props.errors.password}
            onChange={this.props.onChange}
            placeholder={this.props.t('register.passwordPlaceholder')}
          />
          <Input
            type="checkbox"
            name="terms"
            id="termsAgreement"
            value={this.state.terms}
            onChange={this.handleTermsCheck}
            errors={this.props.errors.terms}
            required>
            <label htmlFor="termsAgreement">
              {this.props.t('register.agreeTermsCopy')}
              <span
                tabIndex="0"
                role="button"
                className="btn-link"
                onClick={this.openTermsModal}
                onKeyDown={(e) => e.keyCode === 13 && this.openTermsModal(e)}>
                {` ${this.props.t('common.termsAndConditionsCopy')}`}
              </span>
            </label>
          </Input>
          <div className={`recaptcha-container ${this.props.recaptchaError ? 'error' : ''}`}>
            <ReCAPTCHA
              sitekey="6LfBNw0TAAAAAL16TzcMgB_3WrVibbqWyIF6sq8P"
              onChange={this.handleCaptcha}
              ref={this.recaptchaRef}
              class="g-recaptcha"
            />
          </div>
          {this.props.recaptchaError && (
            <div className="error-message">{this.props.t('register.reCaptcha')}</div>
          )}
          <button type="submit" id="RegisterButton" className="btn btn-primary m-0">
            {this.props.t('register.accountCreateContinue')}
          </button>
          <p className="text-center login-link">
            {this.props.t('register.accountAlreadyHave')}
            <Link to="/login"> {this.props.t('common.labels.clickHere')}</Link>
          </p>

          {this.props.termsCopy && (
            <Modal
              isOpen={this.state.modalIsOpen}
              onRequestClose={this.closeModal}
              className="terms-modal"
              ariaHideApp={false}
              style={modalStyles}>
              <div className="terms-content">{Parser(this.props.termsCopy)}</div>
              <button className="btn btn-outline text-center" onClick={this.closeModal}>
                {this.props.t('common.labels.goBack')}
              </button>
            </Modal>
          )}
        </form>
      </section>
    );
  }
}

RegisterForm.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    emailAddress: PropTypes.string,
    password: PropTypes.string,
  }),
  errors: PropTypes.shape({
    emailAddress: PropTypes.arrayOf(PropTypes.string),
    terms: PropTypes.arrayOf(PropTypes.string),
    password: PropTypes.arrayOf(PropTypes.string),
  }),
  termsCopy: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleCaptcha: PropTypes.func.isRequired,
  recaptchaError: PropTypes.bool,
};

RegisterForm.defaultProps = {
  user: {
    email: '',
    password: '',
  },
  errors: {},
};

export default withTranslation()(RegisterForm);
